angular.module('leanlaw').directive('llIconClose', [function () {
  require("./close.sass");
  return {
    template: `<svg ng-click="closeEntry()" class="ll-icon-close" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <g transform="translate(2.000000, 2.000000)" stroke="#727272">
                  <path d="M0.24,0.24 L11.76,11.76" stroke-width="2"></path>
                  <path d="M0.24,0.24 L11.76,11.76" stroke-width="2" transform="translate(6.000000, 6.000000) scale(-1, 1) translate(-6.000000, -6.000000) "></path>
              </g>
          </svg>`
  };
}]).directive('llIconLeftArrow', [function () {
  return {
    template: `
      <svg width="17px" height="18px" viewBox="0 0 17 18" version="1.1"
      xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="green-left-arrow no-print"
      ng-click="goback()">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="square">
        <g transform="translate(-29.000000, -109.000000)" stroke="#469F66" stroke-width="2">
          <g transform="translate(30.000000, 110.000000)">
            <path d="M8.1,15.1111111 L0.9,8" id="Line-2"
              transform="translate(4.500000, 11.555556) rotate(180.000000) translate(-4.500000, -11.555556) "></path>
            <path d="M8.1,8 L0.9,0.888888889" id="Line-2"
              transform="translate(4.500000, 4.444444) scale(1, -1) rotate(-180.000000) translate(-4.500000, -4.444444) ">
            </path>
            <path d="M1.5,8.33333333 L14.3,8.33333333" id="Line"
              transform="translate(8.000000, 8.166667) rotate(180.000000) translate(-8.000000, -8.166667) "></path>
          </g>
        </g>
      </g>
    </svg>`
  };
}]);